
        var result = require("!!../../../../node_modules/css-loader/index.js!./create-ticket.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/create-ticket/create-ticket.component.css
// module id = 725
// module chunks = 0